var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "add-to-cart-spinner" }, [
      _c("div", { staticClass: "add-to-cart-spinner__gradient" }),
      _vm._v(" "),
      _c("div", { staticClass: "add-to-cart-spinner__inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }